import { Routes, Route, Navigate } from 'react-router-dom'
import { useEffect, useState } from 'react'

import Login from './pages/Login'
import OtpVerify from './pages/OtpVerify'
import Dashboard from './pages/Dashboard'
import RestoreScreen from './pages/RestoreScreen'
import MobileRestriction from './components/MobileRestriction'

function App() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      const isMobileUA = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
      const isSmallScreen = window.innerWidth <= 768;
      setIsMobile(isMobileUA || isSmallScreen);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const [token] = useState(
    localStorage.getItem('token') ||
    localStorage.getItem('login_token')
  )

  if (isMobile) {
    return <MobileRestriction />;
  }

  return (
    <Routes>

      <Route
        path="/"
        element={
          <Navigate
            to={
              token
                ? '/dashboard'
                : '/login'
            }
            replace
          />
        }
      />

      <Route
        path="/login"
        element={
          token
            ? <Navigate to="/dashboard" replace />
            : <Login />
        }
      />

      <Route
        path="/verify-otp"
        element={<OtpVerify />}
      />

      <Route
        path="/dashboard/*"
        element={
          token
            ? <Dashboard />
            : <Navigate to="/login" replace />
        }
      />

      <Route
        path="/restore"
        element={
          token
            ? <RestoreScreen />
            : <Navigate to="/login" replace />
        }
      />

    </Routes>
  )
}

export default App